module.exports = __webpack_public_path__ + "static/media/exist-food-text.abe97354.png";